import React from 'react';

import '@consumer-bootstrap/components/pagination.scss';
import '@consumer-bootstrap/index.scss';

export type PageValuesT = {
  hasMore: boolean;
  limit: number;
  offset: number;
  total: number;
};

export type PaginationLabelT = React.FC<PageValuesT>;

export const PaginationLabel: PaginationLabelT = ({
  offset,
  total,
}) => {
  const firstItem = Math.max(offset + 1, 1);
  const lastItem = offset + total;

  let text = '(0)';

  if ((total ?? 0) > 0) {
    text = `(${firstItem}-${lastItem})`;
  }

  return (
    <span className="pagination-label">
      {text}
    </span>
  );
};
